import AUDIO_USAGES from '@UI/Pages/Administration/AiEngines/audioUsages';

/** The minimal shape this constraint reads: only `usages` drives whether `family` is mandatory. */
type FamilyRequirementShape = {
	readonly usages: string[];
};

/**
 * Generic over the minimal shape it reads, not over `AiModelFormData` itself, so the FormData never
 * has to import its own constraint back (`guides/forms.md` §1.1). A model requires a family if and
 * only if it carries at least one audio usage (`AUDIO_USAGES`); every other model leaves it unset.
 */
function isFamilyRequiredForAudioUsages<T extends FamilyRequirementShape>(
	value: string | null,
	formData: T,
): boolean {
	const hasAudioUsage = formData.usages.some((usage) => AUDIO_USAGES.includes(usage));

	if (!hasAudioUsage) {
		return true;
	}

	return value !== null && value !== '';
}

export default isFamilyRequiredForAudioUsages;
